module.exports = __webpack_public_path__ + "static/AngelaHe9-e541797f7cab6e440956be5da1a38eee.png";